// src/firebase/config.js
// Replace these values with your Firebase project config
// Found at: Firebase Console > Project Settings > General > Your apps > SDK setup

import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjL_maqjK6wziTici39bkZUWsUxtwlm_U",
  authDomain: "app.meeting.training",
  projectId: "meetingtraining",
  storageBucket: "meetingtraining.firebasestorage.app",
  messagingSenderId: "31401840455",
  appId: "1:31401840455:web:74dc95bda01f1b86664662",
  measurementId: "G-TPFKVRS13N"
};


const app = initializeApp(firebaseConfig);

// App Check proves requests come from this app (not a script holding the
// public apiKey). Firebase Console > App Check > register the web app with
// reCAPTCHA Enterprise, then paste its site key here. Nothing is enforced until
// enforcement is switched on per-service in the console.
const RECAPTCHA_ENTERPRISE_SITE_KEY = '6LecN98tAAAAANuJHS2ctwSzLM0CbwjQKPIDPbV0';
if (RECAPTCHA_ENTERPRISE_SITE_KEY) {
  // localhost can't pass reCAPTCHA — the SDK logs a debug token to the console
  // the first time; register it under App Check > Manage debug tokens.
  if (window.location.hostname === 'localhost') window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_ENTERPRISE_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export const auth = getAuth(app);
// The full Firestore SDK keeps a persistent streaming connection open even
// though this app only ever does one-shot getDoc/getDocs (no onSnapshot,
// no offline cache) — that stream is what was stalling repeatedly behind
// VPNs, causing the "keeps hanging" bug. The Lite SDK does plain one-shot
// HTTPS requests per call with no persistent connection to stall.
export const db = getFirestore(app);
export const functions = getFunctions(app);

export default app;
